import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { store, persistor } from "./app/store";
import { theme } from "./theme/theme";
import AppRoutes from "./routes/AppRoutes";
import { GlobalModalsProvider } from "./contexts/GlobalModalsContext";

if (
  process.env.NODE_ENV === "production" &&
  "serviceWorker" in navigator
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          autoHideDuration={3000}
          maxSnack={3}
        >
          <GlobalModalsProvider>
            <AppRoutes />
          </GlobalModalsProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);
